
import React, { Component } from 'react';
import Header from "./Header/Header";
import SideNav from "./Nav/SideNav";
import BreadcrumbMaker from "./BreadcrumbMaker";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import Footer from "./Footer/Footer";
export default class Page404 extends Component {

    render() {
        return (
            <div>
                <div className="main-wrapper">
                    <Header />
                    <section className='text-center'>
                        <div className='error_msg'>
                        <h3>404</h3>
                        <h6>Page Not Found</h6>
                        <p>This page you requested could not be found.</p>
                        <img src='https://www.syncloop.com/assets/img/hero-1.png'></img>
                        </div>
                    </section>
                    <Footer />
                </div>
            </div>
        )
    }

}
